import React from "react";
import Button from "components/CustomButtons/Button.js";
import { Publish as PublishIcon } from "components/MaterialSymbol/MaterialIcons";
import { useConfirmationDialog } from "hooks/useConfirmationDialog";
import { useBackdrop } from "hooks/useBackdrop";
import { useSnackbar } from "hooks/useSnackbar";
import VhostsService from "services/VhostsService";
import { Typography, Box } from "@material-ui/core";

export default function GoLiveButtonV2({
    defaultSourceDealer = "",
    defaultTargetDealer = "",
    dealerDomain = "",
    isPublished = 0,
}) {
    const { openDialog, closeDialog } = useConfirmationDialog();
    const { openBackdrop, closeBackdrop } = useBackdrop();
    const openSnackbar = useSnackbar();

    // Check if the store is already published (normalized for type safety)
    if (Number(isPublished) === 1) return null;

    const handleGoLive = async () => {
        try {
            openBackdrop("Publishing dealer site, please wait...");

            await VhostsService.setupVHosts(defaultSourceDealer, defaultTargetDealer);

            openSnackbar("success", `The dealer site is now live at ${dealerDomain}`);
        } catch (error) {
            console.error(error);
            openSnackbar("error", "An unexpected error occurred while publishing the dealer site.");
        } finally {
            closeBackdrop();
            closeDialog();
        }
    };

    const handleClickGoLive = () => {
        openDialog({
            customDialog: true,
            fullWidth: true,
            maxWidth: "sm",
            showActions: true,
            showClose: true,
            title: "Confirm Go Live",
            confirmButtonStyle: {
                backgroundColor: "#1976d2",
                color: "#fff",
            },
            message: (
                <Box>
                    <Typography variant="body1" gutterBottom>
                        Are you sure you want to publish this dealer site?
                    </Typography>

                    <Typography variant="body2" color="textSecondary">
                        Once confirmed, it will be accessible through:
                    </Typography>

                    <Typography variant="subtitle2" style={{ marginTop: 8 }}>
                        {dealerDomain}
                    </Typography>
                </Box>
            ),
            onConfirm: handleGoLive,
        });
    };

    return (
        <Button
            color="primary"
            className="dealer-profile-action-button"
            onClick={handleClickGoLive}
            disabled={!dealerDomain}
        >
            Go Live <PublishIcon style={{ marginLeft: 6 }} />
        </Button>
    );
}

/*import Button from "components/CustomButtons/Button.js";
import { BackdropProvider } from "hooks/useBackdrop";
import { useConfirmationDialog } from "hooks/useConfirmationDialog";
import GoLiveForm from "components/GoLiveForm/GoLiveForm";
import { Publish as PublishIcon } from "components/MaterialSymbol/MaterialIcons";

export default function GoLiveButtonV2({
    defaultSourceDealer = "",
    defaultTargetDealer = "",
    dealerDomain = "",
    isPublished = 0,
}) {
    const { openDialog, closeDialog } = useConfirmationDialog();

    const handleClickGoLive = () => {
        openDialog({
            customDialog: true,
            fullWidth: true,
            maxWidth: "md",
            message: (
                <BackdropProvider>
                    <GoLiveForm
                        defaultSourceDealer={defaultSourceDealer}
                        defaultTargetDealer={defaultTargetDealer}
                        dealerDomain={dealerDomain}
                        isPublished={isPublished}
                        closeDialog={closeDialog}
                    />
                </BackdropProvider>
            ),
        });
    };

    if (isPublished === 1) {
        return null;
    }

    return (
        <Button color="facebook" onClick={handleClickGoLive}>
            Go Live <PublishIcon style={{ margin: 0 }} />
        </Button>
    );
}*/
